import React, { Fragment } from 'react';
import { Accordion, Icon } from 'semantic-ui-react'


interface AccordionItemProps {
  title: string | JSX.Element,
  description: string,
  active: boolean
  onToggle: () => void;
  statusIcon?: JSX.Element;
  hasError?: boolean
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  description,
  active,
  onToggle,
  hasError,
  children
}) => {
  return (
    <Fragment>
      <Accordion.Title className={hasError ? "error" : ""} active={active} index={0} onClick={onToggle} >
        <Icon name='dropdown' />
        {title}
      </Accordion.Title>
      <Accordion.Content className="AccordionItem-content expand" active={active}>
        <div className="accordion-content-inner">
          <p> {description}  </p>
          {children}
        </div>
      </Accordion.Content>
    </Fragment>
  );
};

